import React from 'react';
import '../short.css';
import axios from 'axios';
import { PayPalButton } from "react-paypal-button-v2";
import { useHistory } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { uuid } from 'uuidv4';
const queryString = require('query-string');


// function getTutor(tutorEmail){
//       var myParam = {
//           email: tutorEmail
//       }
  
//       axios.post("https://auxilliabackend.herokuapp.com/getTutorProfile",myParam)
//     .then(function (response) {
      
//       const data = response.data;
//       console.log(data);

//       var classes = "";
//       for (var i = 0;i <  data.Classes.length;i++)
//       {
//         classes = classes + data.Classes[i] + "\n";
//       }

//       var times = [];
//       for (var i = 0;i <  data.AvailableTimes.length;i++)
//       {
//         times.push(data.AvailableTimes[i]);
//       }




//       window.tutorProf.addTutorToState(data.ClassYear,classes,data.Email,data.Name,data.Price,times);  
//       return data;
  
  
//       //window.location.reload(true);
//     })
//     .catch(function (error) {
//       console.log(error);
//     });
//   }


//   function transSucces()
//   {
//     const history = useHistory();
//     history.push({pathname: '/reserve'});
//   }

//Functional Component 
class shortTransactionsPage extends React.Component{
    constructor(props)
    {
        super(props);
        window.tutorProf = this;
        this.state = {
        classYear: "",
        classes: "",
        email:"",
        name:"",
        price:"",
        times:[]
        }
    }

    componentDidMount()
    {
        const mail = queryString.parse(window.location.search).email;
        // getTutor(mail);
    }

    addTutorToState(classYear,classes,email,name,price,times)
    {
        this.setState({
            classYear: classYear,
            classes: classes,
            email:email,
            name:name,
            price:price,
            times:times
        });
        
    }

    reroute(){
      localStorage.setItem('sessionID',uuid());
      var sample = localStorage.getItem('sessionID');  
         
      var result = `?id=${sample}`;
      this.props.history.push({pathname: '/chats',search:result});
    }
    
    render()
    {
        return (
            <div className="App">
                <body className = "profile-body">
                    <div class = "shortTransac">
                        {/* <p>You have clicked on the option to ask a simple question with a tutor. These are typically questions that can be answered in under 10 minutes. Our system allows you to ask a question to a tutor live in an Instant Message Chat system. To gain acces to this chat you must pay our standard fee of $0.15. Our system requests that you pay our fee before entering the chat, but it will not pay the tutor until after the chat has concluded. If you do not feel that your answer was properly answered then you can look at our FAQ page to see how to reqeust a refund. After you have confirmed the payment you will be redirected to a page that contains the chat.</p> */}
                        <p>Please pay to gain access to a instant message chat with a tutor to answer your simple question. To gain access you must first pay $0.50, then will be redirected to the chat. If your question was not properly answered then please look at our FAQ for a refund.</p>
                        <PayPalButton
                            amount="0.50"
                            shippingPreference="NO_SHIPPING" // default is "GET_FROM_FILE"
                            onSuccess={(details, data) => {
                            console.log("IT WENT THRU");
                            alert("Transaction completed by " + details.payer.name.given_name);
                            {this.reroute()}
                            //this.props.history.push({pathname: '/chatbot',search: result });
                            // OPTIONAL: Call your server to save the transaction
                            // return fetch("/paypal-transaction-complete", {
                            //     method: "post",
                            //     body: JSON.stringify({
                            //     orderId: data.orderID
                            //     })
                            // });
                            }}
                            options={{
                                commit: true,
                                clientId: "Afb7pKFG_ajh6JmL2e0NyBFomaJGCd76qmQ6-eQKKR8sVGLXnM1jxvzADDFzjUKYU5-s8GkLozC-Aj78"
                            }}
                        />
                    </div>
        
                    
                </body>
            </div>
        );
    }
  }



export default shortTransactionsPage;